// extracted by mini-css-extract-plugin
module.exports = {"icon":"PopupMenuIconButton_icon__2DuBy","disabled":"PopupMenuIconButton_disabled__2J5h0"};